/* Isabelle Quinn product cards: hover-slide photos, swipe dots + Quick Buy size pop-up. */
(function(){
  if (window.__iqk) return; window.__iqk = true;

  /* Card photos. Desktop: hovering a product cycles through its photos, leaving returns to the first.
     Phones: no auto-play, shoppers swipe through the photos themselves. */
  (function(){
    var mq = function(q){ return window.matchMedia ? window.matchMedia(q).matches : false; };
    if (mq('(hover: none)')) return;
    var DELAY = 1400;

    function show(s, i){
      var n = s.imgs.length; s.i = ((i % n) + n) % n;
      for (var k = 0; k < n; k++) s.imgs[k].classList.toggle('on', k === s.i);
      var d = s.m.querySelectorAll('.iqk-dots span');
      for (k = 0; k < d.length; k++) d[k].classList.toggle('on', k === s.i);
    }
    function setup(media){
      if (media.__iqk) return;
      var track = media.querySelector('.iqk-track');
      var imgs = track ? track.querySelectorAll('.iqk-img') : [];
      if (imgs.length < 2) return;
      var s = {m: media, imgs: imgs, i: 0, timer: null};
      media.__iqk = s;
      media.classList.add('iqk-auto');
      show(s, 0);
      var card = media.closest('.iqk-card') || media;
      card.addEventListener('mouseenter', function(){
        clearInterval(s.timer); show(s, 1);
        s.timer = setInterval(function(){ show(s, s.i + 1); }, DELAY);
      });
      card.addEventListener('mouseleave', function(){ clearInterval(s.timer); s.timer = null; show(s, 0); });
    }
    function scan(el){
      if (!el || el.nodeType !== 1) return;
      if (el.classList.contains('iqk-media')) setup(el);
      [].forEach.call(el.querySelectorAll('.iqk-media'), setup);
    }
    scan(document.body);
    new MutationObserver(function(ms){ ms.forEach(function(m){ [].forEach.call(m.addedNodes, scan); }); })
      .observe(document.body, {childList: true, subtree: true});
  })();

  /* Card buttons on every product photo: wishlist heart (top left, saved to Wishlist King / Swish) and + quick add (bottom left). */
  (function(){
    var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.6-4.6-9.2-9.4C1.7 7.6 3.9 4.5 7.1 4.5c2 0 3.5 1.1 4.9 2.9 1.4-1.8 2.9-2.9 4.9-2.9 3.2 0 5.4 3.1 4.3 6.4-1.6 4.8-9.2 9.4-9.2 9.4z"/></svg>';
    var PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
    var saved = {}, wkP = null, watching = false;

    function num(x){ var m = String(x == null ? '' : x).match(/(\d+)\s*$/); return m ? m[1] : ''; }
    /* Wishlist King (Swish) app: wait for it to load */
    function wk(){
      if (wkP) return wkP;
      wkP = new Promise(function(res, rej){
        var n = 0;
        (function chk(){
          var W = window.WishlistKing;
          if (W && W._state && W.addWishlistItem) return res(W);
          if (++n > 100) return rej(new Error('wishlist not loaded'));
          setTimeout(chk, 150);
        })();
      });
      return wkP;
    }
    function paint(){
      [].forEach.call(document.querySelectorAll('.iqk-wish'), function(b){
        var on = !!saved[b.getAttribute('data-pid')];
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + b.getAttribute('data-title') + (on ? ' from wishlist' : ' to wishlist'));
      });
    }
    /* Keep every heart in step with the shopper's wishlist (also updates when saved elsewhere on the site) */
    function watch(){
      if (watching) return; watching = true;
      wk().then(function(W){
        W._state.observeWishlist({wishlistId: 'mine'}).subscribe(function(wl){
          var next = {};
          ((wl && wl.items) || []).forEach(function(it){ var p = num(it.product && it.product.id); if (p && it.id) next[p] = it.id; });
          Object.keys(saved).forEach(function(p){ if (saved[p] === 'pending' && !next[p]) next[p] = 'pending'; });
          saved = next; paint();
        });
      }).catch(function(){});
    }
    function toggle(b){
      var pid = b.getAttribute('data-pid'), vid = b.getAttribute('data-vid'), handle = b.getAttribute('data-handle');
      var was = saved[pid];
      if (was === 'pending') return;
      if (was) delete saved[pid]; else saved[pid] = 'pending';
      paint();
      wk().then(function(W){
        if (was) return W.removeWishlistItem({wishlistItemId: was});
        var body = {productHandle: handle};
        if (vid) body.variantId = Number(vid);
        return W.addWishlistItem(body).then(function(r){
          if (r && r.wishlistItem && r.wishlistItem.id) saved[pid] = r.wishlistItem.id;
        });
      }).then(paint).catch(function(){
        if (was) saved[pid] = was; else delete saved[pid];
        paint();
      });
    }

    function decorate(media){
      if (media.__iqkBtns || !media.getAttribute('data-pid')) return;
      media.__iqkBtns = true;
      var card = media.closest('.iqk-card');
      var host = media.closest('.iqk-mwrap') || media.parentNode;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var pid = media.getAttribute('data-pid'), title = media.getAttribute('data-title') || 'this piece';
      var link = (card && card.tagName === 'A') ? card : ((card && card.querySelector('a[href]')) || media.closest('a[href]'));
      var url = link ? link.getAttribute('href') : '';

      var h = document.createElement('button');
      h.type = 'button'; h.className = 'iqk-wish';
      h.setAttribute('data-pid', pid); h.setAttribute('data-vid', media.getAttribute('data-vid') || ''); h.setAttribute('data-handle', media.getAttribute('data-handle') || ''); h.setAttribute('data-title', title);
      h.innerHTML = HEART; host.appendChild(h);

      if (media.getAttribute('data-available') === 'true') {
        var p = document.createElement('button');
        p.type = 'button'; p.className = 'iqk-add';
        p.setAttribute('data-iqk-qb', media.getAttribute('data-handle'));
        p.setAttribute('data-url', url);
        p.setAttribute('aria-label', 'Add ' + title + ' to bag');
        p.innerHTML = PLUS; host.appendChild(p);
      }
      if (card) [].forEach.call(card.querySelectorAll('.iqk-qb'), function(q){ q.remove(); });
      paint();
      watch();
    }

    /* Heart clicks: save or remove, never follow the card link */
    document.addEventListener('click', function(e){
      var b = e.target.closest('.iqk-wish');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      toggle(b);
    }, true);

    function scan(el){
      if (!el || el.nodeType !== 1) return;
      if (el.classList.contains('iqk-media')) decorate(el);
      [].forEach.call(el.querySelectorAll('.iqk-media'), decorate);
    }
    scan(document.body);
    new MutationObserver(function(ms){ ms.forEach(function(m){ [].forEach.call(m.addedNodes, scan); }); })
      .observe(document.body, {childList: true, subtree: true});
  })();

  /* Dots follow the swipe */
  document.addEventListener('scroll', function(e){
    var t = e.target; if (!t || !t.classList || !t.classList.contains('iqk-track')) return;
    var dots = t.parentNode.querySelectorAll('.iqk-dots span'); if (!dots.length) return;
    var i = Math.round(t.scrollLeft / (t.clientWidth || 1));
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('on', k === i);
  }, true);

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
  function money(c){
    var v = c / 100, whole = c % 100 === 0;
    try { return new Intl.NumberFormat('en-AU', {style:'currency', currency:cur, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2}).format(v); }
    catch(e){ return '$' + (whole ? v.toFixed(0) : v.toFixed(2)); }
  }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  var m, lastFocus;
  function build(){
    m = document.createElement('div');
    m.className = 'iqk-qm';
    m.setAttribute('role','dialog'); m.setAttribute('aria-modal','true'); m.setAttribute('aria-labelledby','iqk-qm-t');
    m.innerHTML = '<div class="iqk-qm__bg" data-x></div><div class="iqk-qm__panel" tabindex="-1">' +
      '<button type="button" class="iqk-qm__x" data-x aria-label="Close">&times;</button>' +
      '<div class="iqk-qm__head"><img alt="" hidden><div><p class="iqk-qm__t" id="iqk-qm-t"></p><p class="iqk-qm__p"></p></div></div>' +
      '<div class="iqk-qm__body"></div><p class="iqk-qm__msg" role="status" aria-live="polite"></p>' +
      '<div class="iqk-qm__done"><a href="' + root + 'cart">View bag</a><button type="button" data-x>Keep shopping</button></div>' +
      '<a class="iqk-qm__more" href="#">View full details</a></div>';
    document.body.appendChild(m);
    m.addEventListener('click', function(e){ if (e.target.closest('[data-x]')) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && m.classList.contains('open')) close(); });
  }
  function close(){
    m.classList.remove('show');
    setTimeout(function(){ m.classList.remove('open','added'); }, 300);
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function open(handle, url, btn){
    if (!m) build();
    lastFocus = btn;
    var body = m.querySelector('.iqk-qm__body'), msg = m.querySelector('.iqk-qm__msg');
    m.classList.remove('added'); msg.textContent = ''; body.innerHTML = '<p class="iqk-qm__l">Loading sizes…</p>';
    m.querySelector('.iqk-qm__t').textContent = ''; m.querySelector('.iqk-qm__p').textContent = '';
    m.querySelector('.iqk-qm__more').href = url || (root + 'products/' + handle);
    m.classList.add('open'); requestAnimationFrame(function(){ m.classList.add('show'); });
    document.documentElement.style.overflow = 'hidden';
    m.querySelector('.iqk-qm__panel').focus();

    fetch(root + 'products/' + encodeURIComponent(handle) + '.js').then(function(r){ if (!r.ok) throw 0; return r.json(); }).then(function(p){
      m.querySelector('.iqk-qm__t').textContent = p.title;
      m.querySelector('.iqk-qm__p').textContent = (p.price_varies ? 'From ' : '') + money(p.price);
      var img = m.querySelector('.iqk-qm__head img');
      if (p.featured_image) { img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200'; img.hidden = false; } else { img.hidden = true; }

      var v = p.variants || [];
      if (v.length === 1) {
        var ok = v[0].available;
        body.innerHTML = '<button type="button" class="iqk-qm__single" data-v="' + v[0].id + '"' + (ok ? '' : ' disabled') + '>' + (ok ? 'Add to bag' : 'Sold out') + '</button>';
      } else {
        var oi = 0;
        (p.options || []).forEach(function(o, i){ if (/size/i.test(o.name || o)) oi = i; });
        var opt = p.options[oi], name = (opt && opt.name) || 'Size', vals = (opt && opt.values) || [];
        var html = '<p class="iqk-qm__l">Select ' + esc(name.toLowerCase()) + '</p><div class="iqk-qm__sizes">';
        vals.forEach(function(val){
          var match = v.filter(function(x){ return x.options[oi] === val; });
          var pick = match.filter(function(x){ return x.available; })[0];
          html += '<button type="button" class="iqk-qm__s"' + (pick ? ' data-v="' + pick.id + '"' : ' disabled aria-label="' + esc(val) + ', sold out"') + '>' + esc(String(val).replace(/^AU\s*/i, '')) + '</button>';
        });
        body.innerHTML = html + '</div>';
      }
    }).catch(function(){
      body.innerHTML = ''; msg.textContent = 'Sizes could not load. Tap View full details to choose your size.';
    });
  }

  function add(id, el){
    var msg = m.querySelector('.iqk-qm__msg');
    el.classList.add('busy'); msg.textContent = 'Adding…';
    fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id: Number(id), quantity: 1}]})})
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(){
        msg.textContent = 'Added to your bag.'; m.classList.add('added');
        return fetch(root + 'cart.js').then(function(r){ return r.json(); }).then(function(cart){
          var n = cart.item_count;
          [].forEach.call(document.querySelectorAll('[data-cart-count],[data-header-cart-count],.cart-count,.header__cart-count,.cart-count-bubble span'), function(c){ c.textContent = n; });
          ['theme:cart:refresh','cart:refresh','cart:updated','theme:cart:change'].forEach(function(ev){ document.dispatchEvent(new CustomEvent(ev, {bubbles:true, detail:{cart: cart}})); });
          /* Open the same slide-out bag every add-to-bag uses */
          var drawer = document.querySelector('cart-drawer');
          if (drawer) { close(); setTimeout(function(){ drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show')); }, 380); }
        });
      })
      .catch(function(err){ msg.textContent = (err && (err.description || err.message)) || 'That size could not be added. Please try again.'; })
      .then(function(){ el.classList.remove('busy'); });
  }

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-iqk-qb]');
    if (b) { e.preventDefault(); e.stopPropagation(); open(b.getAttribute('data-iqk-qb'), b.getAttribute('data-url'), b); return; }
    if (m && m.classList.contains('open')) {
      var s = e.target.closest('.iqk-qm [data-v]');
      if (s && !s.disabled) add(s.getAttribute('data-v'), s);
    }
  }, true);
})();
